import { GET_ALL_MP } from "../actions/MP.actions";

const initialState = {};

export default function MPreducer(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_MP:
      return action.payload;
    default:
      return state;
  }
}
